import React, { useEffect } from 'react';
import useDocket from "../../hooks/useDocket";
import usePdfGenerator from "../../hooks/usePdfGenerator";

// Hooks du composant
import { useTableHeight } from './hooks/useTableHeight';
import { useYearSelection } from './hooks/useYearSelection';
import { useDocketActions } from './hooks/useDocketActions';

// Components du composant
import DocketHeader from './components/DocketHeader';
import YearSelector from './components/YearSelector';
import DocketTable from './components/DocketTable';
import LoadingSpinner from './components/LoadingSpinner';
import PdfReaderModal from '../modals/PdfReaderModal';

// Colonnes du composant
import { createTableColumns } from "./utils/columnHelper";

const DocketContainer = () => {

  const { selectedYear, handleYearChange } = useYearSelection();
  const { tableHeight, containerRef } = useTableHeight();

  const { loading: docketLoading, data, listDockets } = useDocket();
  const { generatePdf, closeModal, pdfUrl, modalOpen, loading: pdfLoading } = usePdfGenerator();
  const { handlePrint } = useDocketActions(generatePdf);

  const { number, years, dockets } = data;
  const isLoading = docketLoading || pdfLoading;
  const columns = createTableColumns(handlePrint);

  useEffect(() => {
    listDockets(selectedYear).then();
  }, [listDockets, selectedYear]);

  return (
    <>
      <LoadingSpinner loading={isLoading} />
      <div style={{ padding: 10 }}>
        <DocketHeader number={number} />
        <YearSelector
          selectedYear={selectedYear}
          years={years}
          onYearChange={handleYearChange}
        />
      </div>
      <DocketTable
        dockets={dockets}
        columns={columns}
        tableHeight={tableHeight}
        containerRef={containerRef}
      />
      <PdfReaderModal
        open={modalOpen}
        onCancel={closeModal}
        pdfUrl={pdfUrl}
        title="Bordereau"
      />
    </>
  );
};


export default DocketContainer ;